"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var integralMall_1 = require("../../model/integralMall");
var service_1 = require("../../../library/base/service");
var ProductDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ProductDetail, _super);
    function ProductDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '微信端商品详情';
        _this.code = '301147';
        _this.desc = '微信端商品详情';
        _this.requestParams = new integralMall_1.ProductDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ProductDetail;
}(service_1.BaseService));
exports.ProductDetail = ProductDetail;
//# sourceMappingURL=productDetail.js.map